import axiosInstance from "../../apiAxios/axiosInstance";


// export const getDashboardCountList = async () => {
//   const response = await axiosInstance.get("/admin/dashboard-count-list" );
//   return response.data;
// };
export const PieCharData = async () => {
  const response = await axiosInstance.get("admin/piechart-dashboard-count", );
  return response.data;
};
export const getDashboardCountList = async () => {
  const res = await axiosInstance.get(
    "/admin/dashboard-count-list"
  );
  return res.data;
};
 
export const getTodayDashboardCountList = async () => {
  const res = await axiosInstance.get(
    "/admin/today-dashboard-count-list"
  );
  return res.data;
};

